"use client";

import { useEffect, useRef } from "react";
import parse, { domToReact } from "html-react-parser";
import ReadingProgressBar from "@/app/lib/ReadingProgressBar";
import { InArticleAd } from "../../AdsBox/AdsBox";

export default function AdditionalContent({ sections = "" }) {
  const contentRef = useRef(null);

  // ❌ Remove script tags
  const cleanHtml = sections?.replace(/<script.*?>.*?<\/script>/gi, "");

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://platform.twitter.com/widgets.js"]',
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;

      script.onload = () => {
        if (window.twttr) {
          window.twttr.widgets.load();
        }
      };

      document.body.appendChild(script);
    } else {
      if (window.twttr) {
        window.twttr.widgets.load();
      }
    }
  }, [cleanHtml]);

  // let paragraphCount = 0;

  // const options = {
  //   replace: (node) => {
  //     // ✅ Target only <p> tags
  //     if (node.name === "p") {
  //       paragraphCount++;

  //       return (
  //         <>
  //           <p>{domToReact(node.children)}</p>

  //           {/* ✅ हर 3rd paragraph के बाद ad */}
  //           {paragraphCount % 3 === 0 && (
  //             <div className="my-4">
  //               <InArticleAd />
  //             </div>
  //           )}
  //         </>
  //       );
  //     }
  //   },
  // };

  return (
    <>
      <ReadingProgressBar targetRef={contentRef} />

      <div className="mb-8" ref={contentRef}>
        <div className="mb-6">
          <div className="blog-content">{parse(cleanHtml || "")}</div>
          {/* <div className="blog-content">{parse(cleanHtml || "", options)}</div> */}
        </div>
      </div>
    </>
  );
}
